import "babel-polyfill";
import './app.css';


/* swiper.js */

import Swiper from '../node_modules/swiper/dist/js/swiper.min.js';



/* is production */
const isProd = process.env.NODE_ENV === 'production';

/* eslint-disable no-unused-vars*/
/* eslint-disable no-console*/



/* meta */
const meta = require('./js/meta.json');

/* data [UNCOMMENT THE LINE BELOW TO USE TEXTS FROM DATA IN JS] */
const data = require('./js/data.json');

var isMobile = false; 
if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) 
    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {isMobile = true;}


/* analytics */
/* SEND EVENT: analyticsEvent('Button', 'click', {eventLabel: 'Play'}); */
const analytics = require('universal-ga');

analytics.initialize(meta.trackingID);
analytics.pageview('/index');

if (meta.clientTrackingID.length > 0) {
    analytics.create(meta.clientTrackingID, 'clientTracker');
    analytics.name('clientTracker').pageview('/index');
}

const analyticsEvent = (category, action, options) => {
    analytics.event(category, action, options);

    if (meta.clientTrackingID.length > 0) {
        analytics.name('clientTracker').event(category, action, options);
    }
};

analyticsEvent('Page', 'load', {eventLabel: 'Successfully'});



/* fonts */
const WebFont = require('webfontloader');

WebFont.load({
    custom: {
        families: ['Proxima Nova:n3,n4'],
        urls: ['./css/fonts.css']
    },
    google: {
        families: ['Roboto:300,400,500,700,900:cyrillic']
    }
});



/* share */
import * as VanillaSharing from 'vanilla-sharing';

const shareButtons = [...document.querySelectorAll('.share__item')];

if (shareButtons.length > 0) {

    const shareOptions = {
        url: meta.url,
        title: meta.title,
        description: meta.description,
        image: meta.image,
        isVkParse: false,
        fbAppId: meta.fbappid
    };

    shareButtons.forEach(button => {
        button.addEventListener('click', () => {
            VanillaSharing[button.dataset.social](shareOptions);

            analyticsEvent('Share', 'click', {eventLabel: 'Social: ' + button.dataset.social});
        });
    });

}



/* service worker */
if ('serviceWorker' in navigator && isProd) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('./sw.js');
    });
}

/* in view */
const inView = require('in-view');

inView('.inview')
    .on('enter', elem => {
        elem.setAttribute('data-inview', 'true');
    })
    .on('exit', elem => {
        elem.removeAttribute('data-inview');
    });


/* image lazy load */

[].forEach.call(document.querySelectorAll('img[data-src]'), function(img) {
    img.setAttribute('src', img.getAttribute('data-src'));
    img.onload = function() {
        img.removeAttribute('data-src');
    };
});


/* youtube background */

var controlsVar = 0;

if (isMobile) { controlsVar = 1 }

function onYouTubeIframeAPIReady() {
  let player;
  player = new YT.Player('bgvid', {
    videoId: 'WfI69DC_jaw', // YouTube Video ID
    playerVars: {
      origin: 'https://murakami.lenta.ru/',
      autoplay: 1,        // Auto-play the video on load
      controls: controlsVar,        // Show pause/play buttons in player
      showinfo: 0,        // Hide the video title
      start: 30,
      rel: 0,
      modestbranding: 1,  // Hide the Youtube Logo
      loop: 1,            // Run the video in a loop
      fs: 0,              // Hide the full screen button
      cc_load_policy: 0, // Hide closed captions
      iv_load_policy: 3,  // Hide the Video Annotations
      autohide: 0,         // Hide video controls when playing
      playsinline: 1
    },
    events: {
      onReady: function(e) {
        e.target.mute();
        if(isMobile) { e.target.playVideo();}
       
      }
    }
  });

  
 }

function secondVidStart() {
   let playertwo;
  playertwo = new YT.Player('bgvidtwo', {
    videoId: 'OH8mkB3QXuM', // YouTube Video ID
    playerVars: {
      origin: 'https://murakami.lenta.ru/',
      autoplay: 1,        // Auto-play the video on load
      controls: controlsVar,        // Show pause/play buttons in player
      showinfo: 0,        // Hide the video title
      start: 20,
      rel: 0,
      modestbranding: 1,  // Hide the Youtube Logo
      loop: 1,            // Run the video in a loop
      fs: 0,              // Hide the full screen button
      cc_load_policy: 0, // Hide closed captions
      iv_load_policy: 3,  // Hide the Video Annotations
      autohide: 0,         // Hide video controls when playing
      playsinline: 1
    },
    events: {
      onReady: function(e) {
        e.target.mute();
        if(isMobile) { e.target.playVideo();}
      }
    }
  }); 
}


let sideMenuWatcher = () => {
    let navElem = document.getElementById('sidepanel'); 
    let pyo = window.pageYOffset;
    let headElem = document.getElementById('zeroblock');
    let headElemHeight = headElem.clientHeight;

    if (pyo > headElemHeight) {
        navElem.style.pointerEvents = "all";
        navElem.style.opacity = 1;
    } else {
        navElem.style.opacity = 0;
        navElem.style.pointerEvents = "none";
    }
}

window.addEventListener("scroll", sideMenuWatcher );

let flowerBlock = document.getElementById('flowercontainer-untouch');
let flowerElement = document.getElementById('flowercontainer-untouch-flowerone');
let flowerHead = document.getElementById('floweronehead');

let mushroomBlock = document.getElementById('mushroom-eye-container');

let catchflowers = document.querySelectorAll('.catch');
let catchMushrooms = document.querySelectorAll('.eye');

for (let flower of catchflowers ) {
    flower.setAttribute('data-position', 'static')
}

for (let mushroom of catchMushrooms ) {
    mushroom.setAttribute('data-position', 'static')
}

let flowerBodys = document.querySelectorAll('.flower');

let hideBranch = (flowerid) => {
   for (let flower of flowerBodys ) {
        if (flowerid === flower.id) {
            flower.classList.add("hide")
        }
    } 
}

let showBranch = (flowerid) => {
   for (let flower of flowerBodys ) {
        if (flowerid === flower.id) {
            flower.classList.remove("hide")
        }
    } 
}

let kikikaikaiHost = document.getElementById('kikikaikai-host');
let kikikaikai = document.getElementById('kikikaikai');

if (!isMobile) {

let desktopIteract = () => {

    /* catch flowers */
    let hostcoords = flowerBlock.getBoundingClientRect();

    for (let flower of catchflowers ) {
        let coords = flower.getBoundingClientRect();
        let offset = parseInt(flower.getAttribute('data-offset'));
        let flowerid = flower.getAttribute('data-branch');
        if (coords.top < 0 && flower.getAttribute('data-position') === 'static') {
            flower.setAttribute('data-position', 'fixed');
            flower.classList.add('fix');            
            hideBranch(flowerid);
          }
        if( flower.getAttribute('data-position') === 'fixed' && hostcoords.bottom + offset < coords.height) {
            flower.setAttribute('data-position', 'bottom');
            flower.classList.remove('fix');
            flower.classList.add('bottom');
            flower.setAttribute('style', `bottom: -${offset}px!important`);
          }
        if( flower.getAttribute('data-position') === 'fixed' && hostcoords.top > 0) {
            flower.setAttribute('data-position', 'static');
            flower.classList.remove('fix');
            showBranch(flowerid);
          }
    }

    /* catch mushrooms */



    let hostcoordsmushrooms = mushroomBlock.getBoundingClientRect();

    for (let flower of catchMushrooms ) {
        let coords = flower.getBoundingClientRect();
        let offset = parseInt(flower.getAttribute('data-offset'));        
        if (coords.top < 0 && flower.getAttribute('data-position') === 'static') {
            flower.setAttribute('data-position', 'fixed');
            flower.classList.add('fix');            
          }
        if( flower.getAttribute('data-position') === 'fixed' && hostcoordsmushrooms.bottom + offset < coords.height) {
            flower.setAttribute('data-position', 'bottom');
            flower.classList.remove('fix');
            flower.classList.add('bottom');
            flower.setAttribute('style', `bottom: -${offset}px!important`);
          }
        if( flower.getAttribute('data-position') === 'fixed' && hostcoordsmushrooms.top > 0) {
            flower.setAttribute('data-position', 'static');
            flower.classList.remove('fix');
          }

    }


    let hostkikikaikaicoords = kikikaikaiHost.getBoundingClientRect();
    if ( hostkikikaikaicoords.y < 500) {
        kikikaikai.classList.add('show');
    }
}

window.addEventListener('scroll', desktopIteract);


/* eyes blinking system */
let eyes = document.getElementsByClassName('eye');
let eyeBlink = () => {
    let index = Math.floor(Math.random() * eyes.length) + 1;
    eyes[index-1].classList.add('blink');
    setTimeout( function() { eyes[index-1].classList.remove('blink'); } , 500)

}
let randomBlink = () => {
  let min = 1,
      max = 4;
  let rand = Math.floor(Math.random() * (max - min + 1) + min);
  eyeBlink();
  setTimeout(randomBlink, rand * 1000);
}
randomBlink();

}


/* sliders initialize */


var blueSwiper = new Swiper('.blue-swiper-container', { 
    loop: true,
    lazy: true,
    autoplay: {
        delay: 2000,
        disableOnInteraction: false
      },
    navigation: {
        nextEl: '.blue-swiper-button-next',
        prevEl: '.blue-swiper-button-prev'
      }
 });


var blueSwiperTwo = new Swiper('.blue-second-swiper-container', { 
    loop: true,
    lazy: true,
    autoplay: {
        delay: 2000,
        disableOnInteraction: false
      },
    navigation: {
        nextEl: '.blue-swiper-button-next',
        prevEl: '.blue-swiper-button-prev'
      }
 });

var yellowSwiper = new Swiper('.yellow-swiper-container', { 
    loop: true,
    lazy: true,
    autoplay: {
        delay: 2000,
        disableOnInteraction: false
      },
    navigation: {
        nextEl: '.yellow-swiper-button-next',
        prevEl: '.yellow-swiper-button-prev'
      }
 });

var yellowSwiperTwo = new Swiper('.yellow-second-swiper-container', { 
    loop: true,
    lazy: true,
    autoplay: {
        delay: 2000,
        disableOnInteraction: false
      },
    navigation: {
        nextEl: '.yellow-swiper-button-next',
        prevEl: '.yellow-swiper-button-prev'
      }
 });

var greenSwiper = new Swiper('.green-swiper-container', { 
    loop: true,
    lazy: true,
    autoplay: {
        delay: 2000,
        disableOnInteraction: false
      },
    navigation: {
        nextEl: '.green-swiper-button-next',
        prevEl: '.green-swiper-button-prev'
      }
 });

var greenSwiperTwo = new Swiper('.green-second-swiper-container', { 
    loop: true,
    lazy: true,
    autoplay: {
        delay: 2000,
        disableOnInteraction: false
      },
    navigation: {
        nextEl: '.green-swiper-button-next',
        prevEl: '.green-swiper-button-prev'
      }
 });

var pinkSwiper = new Swiper('.pink-swiper-container', { 
    loop: true,
    lazy: true,
    autoplay: {
        delay: 2000,
        disableOnInteraction: false
      },
    navigation: {
        nextEl: '.pink-swiper-button-next',
        prevEl: '.pink-swiper-button-prev'
      }
 });

var pinkSwiperTwo = new Swiper('.pink-second-swiper-container', { 
    loop: true,
    lazy: true,
    autoplay: {
        delay: 2000,
        disableOnInteraction: false
      },
    navigation: {
        nextEl: '.pink-swiper-button-next',
        prevEl: '.pink-swiper-button-prev'
      }
 });

setTimeout(function() {
    blueSwiper.update();
    blueSwiperTwo.update();
    yellowSwiper.update();
    yellowSwiperTwo.update();
    greenSwiper.update();
    greenSwiperTwo.update();
    pinkSwiper.update();
    pinkSwiperTwo.update();
}, 1000)


/* waves */
/* eslint-disable no-inner-declarations*/

const ease = {
  exponentialIn: (t) => {
    return t === 0.0 ? t : Math.pow(2.0, 10.0 * (t - 1.0));
  },
  exponentialOut: (t) => {
    return t === 1.0 ? t : 1.0 - Math.pow(2.0, -10.0 * t);
  },
  exponentialInOut: (t) => {
    return t === 0.0 || t === 1.0
      ? t
      : t < 0.5
        ? +0.5 * Math.pow(2.0, 20.0 * t - 10.0)
        : -0.5 * Math.pow(2.0, 10.0 - t * 20.0) + 1.0;
  },
  sineOut: (t) => {
    const HALF_PI = 1.5707963267948966;
    return Math.sin(t * HALF_PI);
  },
  circularInOut: (t) => {
    return t < 0.5
        ? 0.5 * (1.0 - Math.sqrt(1.0 - 4.0 * t * t))
        : 0.5 * (Math.sqrt((3.0 - 2.0 * t) * (2.0 * t - 1.0)) + 1.0);
  },
  cubicIn: (t) => {
    return t * t * t;
  },
  cubicOut: (t) => {
    const f = t - 1.0;
    return f * f * f + 1.0;
  },
  cubicInOut: (t) => {
    return t < 0.5
      ? 4.0 * t * t * t
      : 0.5 * Math.pow(2.0 * t - 2.0, 3.0) + 1.0;
  },
  quadraticOut: (t) => {
    return -t * (t - 2.0);
  },
  quarticOut: (t) => {
    return Math.pow(t - 1.0, 3.0) * (1.0 - t) + 1.0;
  }
}

class ShapeOverlays {
  constructor(elm) {
    this.elm = elm;
    this.path = elm.querySelectorAll('path');
    this.numPoints = 6;
    this.duration = 1200;
    this.delayPointsArray = [];
    this.delayPointsMax = 580;
    this.delayPerPath = 170;
    this.timeStart = Date.now();
    this.isOpened = false;
    this.isAnimating = false;
  }
  toggle() {
    this.isAnimating = true;
    const range = Math.random() * Math.PI * 2;
    for (var i = 0; i < this.numPoints; i++) {
      const radian = i / (this.numPoints - 1) * Math.PI * 2;
      this.delayPointsArray[i] = (Math.sin(radian + range) + 1) / 2 * this.delayPointsMax;
    }
    if (this.isOpened === false) {
      this.open();
    } else {
      this.close();
    }
  }
  open() {
    this.isOpened = true;
    this.elm.classList.add('is-opened');
    this.timeStart = Date.now();
    this.renderLoop();
  }
  close() {
    this.isOpened = false;
    this.elm.classList.remove('is-opened');
    this.timeStart = Date.now();
    this.renderLoop();
  }
  updatePath(time) {
    const points = [];
    for (let i = 0; i < this.numPoints; i++) {
      points[i] = ease.cubicInOut(Math.min(Math.max(time - this.delayPointsArray[i], 0) / this.duration, 1)) * 100
    }

    let str = '';
    str += this.isOpened ? `M 0 0 V ${points[0]} ` : `M 0 ${points[0]} `;
    for (let i = 0; i < this.numPoints - 1; i++) {
      const p = (i + 1) / (this.numPoints - 1) * 100;
      const cp = p - 1 / (this.numPoints - 1) * 100 / 2;
      str += `C ${cp} ${points[i]} ${cp} ${points[i + 1]} ${p} ${points[i + 1]} `;
    }
    str += this.isOpened ? `V 0 H 0` : `V 100 H 0`;
    return str;
  }
  render() {
    if (this.isOpened) {
      for (let i = 0; i < this.path.length; i++) {
        this.path[i].setAttribute('d', this.updatePath(Date.now() - (this.timeStart + this.delayPerPath * i)));
      }
    } else {
      for (let i = 0; i < this.path.length; i++) {
        this.path[i].setAttribute('d', this.updatePath(Date.now() - (this.timeStart + this.delayPerPath * (this.path.length - i - 1))));
      }
    }
  }
  renderLoop() {
    this.render();
    if (Date.now() - this.timeStart < this.duration + this.delayPerPath * (this.path.length - 1) + this.delayPointsMax) {
      requestAnimationFrame(() => {
        this.renderLoop();
      });
    }
    else {
      this.isAnimating = false;
    }
  }
}



const curtainOffset = 300;

const elmHamburger = document.querySelector('.textcont-head');
const elmOverlay = document.querySelector('.shape-overlays');
const elmOverlayYellow = document.querySelector('.shape-overlays__yellow');
const elmOverlayLightblue = document.querySelector('.shape-overlays__lightblue');
const elmOverlayGreen = document.querySelector('.shape-overlays__green');
const elmOverlayPink = document.querySelector('.shape-overlays__pink');
const elmOverlayBlue = document.querySelector('.shape-overlays__blue');
const overlay = new ShapeOverlays(elmOverlay);
const overlayYellow = new ShapeOverlays(elmOverlayYellow);
const overlayLightblue = new ShapeOverlays(elmOverlayLightblue);
const overlayGreen = new ShapeOverlays(elmOverlayGreen);
const overlayPink = new ShapeOverlays(elmOverlayPink);
const overlayBlue = new ShapeOverlays(elmOverlayBlue);
const firstPage = document.getElementById('firstpage');
const animationContainer = document.getElementById('animation-container');

document.addEventListener('DOMContentLoaded', () => {
if (overlay.isAnimating) {
  return false;
}
overlay.toggle();

setTimeout(function() { 
    firstPage.classList.remove('hide');
    firstPage.classList.add('show');
    setTimeout(function() { 
        animationContainer.classList.add('show');
        onYouTubeIframeAPIReady(); 
    }, 1000);
 }, 2000);

});

/* blue curtain */

let blueBlock = document.getElementById('firstblock');
let bluePaintTrigger = false;

let showBlueCurtain = () => {
    if (bluePaintTrigger === false) {
        let blueBlockCoords = blueBlock.getBoundingClientRect();
        if ( blueBlockCoords.y < curtainOffset) {
            overlayBlue.toggle();
            bluePaintTrigger = true;
        }
    }
}

window.addEventListener('scroll', showBlueCurtain);

/* yellow curtain */

let yellowBlock = document.getElementById('secondblock');
let yellowPaintTrigger = false;
let mushroomsBodys = document.querySelectorAll('.mushroom');

let showYellowCurtain = () => {
    if (yellowPaintTrigger === false) {
        let yellowBlockCoords = yellowBlock.getBoundingClientRect();
        if ( yellowBlockCoords.y < curtainOffset) {
            overlayYellow.toggle();
            yellowPaintTrigger = true;
            setTimeout(function() { 
                document.getElementById('mushroom-centerblock').classList.add('show');
                for (let mushroom of mushroomsBodys ) {
                    if (mushroom.id === 'mushroom7') {
                        mushroom.classList.add('show');
                        setTimeout(function() { 
                            document.getElementById('mushroom-eye-container').classList.add('show');
                        }, 600);                        
                    } else{
                        let min = 1,
                        max = 4;
                        let rand = Math.floor(Math.random() * (max - min + 1) + min);
                        setTimeout(function() { 
                            mushroom.classList.add('show');
                        }, rand * 300);
                    }
                 }
             }, 1000);
        }

    }
}

window.addEventListener('scroll', showYellowCurtain);

/* lightblue curtain */

let lightblueBlock = document.getElementById('thirdblock');
let lightbluePaintTrigger = false;
let clouds = document.getElementById('clouds-container');
let cloudsText = document.getElementById('clouds-centerblock');


let showLightblueCurtain = () => {
    if (lightbluePaintTrigger === false) {
        let lightblueBlockCoords = lightblueBlock.getBoundingClientRect();
        if ( lightblueBlockCoords.y < curtainOffset) {
            overlayLightblue.toggle();
            lightbluePaintTrigger = true;

            setTimeout(function() {
                clouds.classList.remove('hide');
                setTimeout(function() {
                   cloudsText.classList.remove('hide');
                }, 1000);
            }, 1000);

        }

    }
}

window.addEventListener('scroll', showLightblueCurtain);


/* green curtain */

let greenBlock = document.getElementById('fourthblock');
let greenPaintTrigger = false;
let acidCloudsBlock = document.getElementById('acidclouds-container');

let showGreenCurtain = () => {
    if (greenPaintTrigger === false) {
        let greenBlockCoords = greenBlock.getBoundingClientRect();
        if ( greenBlockCoords.y < curtainOffset) {
            overlayGreen.toggle();
            greenPaintTrigger = true;

            setTimeout(function() {
                acidCloudsBlock.classList.remove('hide');
                secondVidStart();
            }, 1000);

        }

    }
}

window.addEventListener('scroll', showGreenCurtain);

/* pink curtain */

let pinkBlock = document.getElementById('fifthblock');
let pinkPaintTrigger = false;
let toysBlock = document.getElementById('toys-container');

let showPinkCurtain = () => {
    if (pinkPaintTrigger === false) {
        let pinkBlockCoords = pinkBlock.getBoundingClientRect();
        if ( pinkBlockCoords.y < curtainOffset) {
            overlayPink.toggle();
            pinkPaintTrigger = true;

            setTimeout(function() {
                toysBlock.classList.remove('hide');
            }, 1000);
        }
    }
}

window.addEventListener('scroll', showPinkCurtain);

/* eslint-enable no-inner-declarations*/

/* ga events */

let ingoslink = document.getElementById('ingoslink');

ingoslink.addEventListener('click', function() {
    analyticsEvent('Test', 'click', {eventLabel: 'Test button pressed'});
})


const sidemenuButtons = [...document.querySelectorAll('.sidelink')];

sidemenuButtons.forEach(button => {
        button.addEventListener('click', () => {
            analyticsEvent('Sidemenu', 'click', {eventLabel: 'Anchor: ' + button.href});
        });
    });


/*

document.addEventListener("DOMContentLoaded", onYouTubeIframeAPIReady);
window.onload = () =>{
    onYouTubeIframeAPIReady();
}
*/







// WEBPACK FOOTER //
// ./app.js